import {
  ClearOutlined,
  FileExcelOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { Button, Input, Select, Space, message } from "antd";
import { debounce } from "lodash";
import * as XLSX from "xlsx";

export function EventAttendanceFilter({
  filter = { page: 1, limit: 10 },
  onSearchChange,
  data,
  hasPermission,
  hasRefugeCeremony,
}) {
  const handleExportExcel = () => {
    if (!data || data.length === 0) {
      message.warning("Không có dữ liệu để xuất!");
      return;
    }

    // Chuẩn bị dữ liệu cho Excel
    const excelData = data.map((item, index) => {
      const costumeType = item.costume?.type === "borrow" ? "Mượn" : "Mua";
      const costumeStatus =
        item.costume?.type === "borrow"
          ? {
              pending: "Chờ nhận",
              borrowed: "Đã mượn",
              returned: "Đã trả",
              lost: "Mất",
              cancelled: "Đã hủy",
            }[item.costume?.borrowStatus] || item.costume?.borrowStatus
          : {
              paid: "Đã thanh toán",
              unpaid: "Chưa thanh toán",
              cancelled: "Đã hủy",
            }[item.costume?.buyStatus] || item.costume?.buyStatus;

      const statusMap = {
        registered: "Đã đăng ký",
        attended: "Đã tham gia",
        cancelled: "Đã hủy",
      };

      return {
        STT: (filter.page - 1) * filter.limit + index + 1,
        "Họ và tên": item.user?.name || "",
        Email: item.user?.email || "",
        "Số điện thoại": item.user?.phone || "",
        "QR Code": item.qrCode || "",
        "Giới tính": item.user?.gender
          ? item.user.gender === "male"
            ? "Nam"
            : "Nữ"
          : "",
        "Địa chỉ": item.user?.address || "",
        "Ngày sinh": item.user?.birthday
          ? new Date(item.user.birthday).toLocaleDateString("vi-VN")
          : "",
        "Ngày đăng ký": item.registrationDate
          ? new Date(item.registrationDate).toLocaleDateString("vi-VN")
          : "",
        "Loại áo": costumeType,
        "Trạng thái áo": costumeStatus || "",
        "Size áo": item.costume?.size || "",
        "Trạng thái": statusMap[item.status] || item.status,
        "Thời gian check-in": item.checkInTime
          ? new Date(item.checkInTime).toLocaleString("vi-VN")
          : "",
      };
    });

    // Tạo workbook và worksheet
    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Danh sách tham gia");

    // Điều chỉnh độ rộng cột
    const columnWidths = [
      { wch: 5 }, // STT
      { wch: 25 }, // Họ và tên
      { wch: 30 }, // Email
      { wch: 15 }, // Số điện thoại
      { wch: 15 }, // QR Code
      { wch: 15 }, // Ngày đăng ký
      { wch: 10 }, // Loại áo
      { wch: 18 }, // Trạng thái áo
      { wch: 10 }, // Size áo
      { wch: 15 }, // Trạng thái
      { wch: 20 }, // Thời gian check-in
    ];
    worksheet["!cols"] = columnWidths;

    // Xuất file
    const fileName = `danh-sach-tham-gia-${new Date().toISOString().split("T")[0]}.xlsx`;
    XLSX.writeFile(workbook, fileName);
    message.success("Xuất Excel thành công!");
  };

  const handleSearch = debounce((key, value) => {
    const newFilter = { ...filter, [key]: value, page: 1 };
    onSearchChange?.(newFilter);
  }, 300);

  const handleChange = (key, value) => {
    const newFilter = { ...filter, [key]: value, page: 1 };
    onSearchChange?.(newFilter);
  };

  const handleClear = () => {
    onSearchChange?.({ page: 1, limit: filter.limit || 10 });
  };

  return (
    <div
      style={{
        marginBottom: 16,
        display: "flex",

        alignItems: "center",
        flexWrap: "wrap",
        gap: 12,
      }}
    >
      <Input
        placeholder="Tìm kiếm theo tên, email,sđt, mã tham dự hoặc QR code"
        prefix={<SearchOutlined />}
        onChange={(e) => handleSearch("search", e.target.value)}
        value={filter.search || ""}
        allowClear
        style={{ width: 400 }}
      />

      <Select
        placeholder="Lọc theo trạng thái"
        onChange={(value) => handleChange("status", value)}
        style={{ width: 150 }}
        allowClear
        value={filter.status || ""}
      >
        <Select.Option value="">Tất cả</Select.Option>
        <Select.Option value="registered">Đã đăng ký</Select.Option>
        <Select.Option value="attended">Đã tham gia</Select.Option>
        <Select.Option value="cancelled">Đã hủy</Select.Option>
      </Select>

      {hasRefugeCeremony && (
        <Select
          placeholder="Lọc theo Quy Y Tam Bảo"
          onChange={(value) =>
            handleChange(
              "isTakingRefuge",
              value === "" ? undefined : value === "true"
            )
          }
          style={{ width: 180 }}
          allowClear
          value={
            filter.isTakingRefuge === undefined
              ? ""
              : String(filter.isTakingRefuge)
          }
        >
          <Select.Option value="">Tất cả</Select.Option>
          <Select.Option value="true">Tham dự</Select.Option>
          <Select.Option value="false">Không tham dự</Select.Option>
        </Select>
      )}

      <Button icon={<ClearOutlined />} onClick={handleClear}>
        Xóa bộ lọc
      </Button>

      <div style={{ flexGrow: 1 }} />

      <Space>
        {hasPermission && (
          <Button
            type="primary"
            icon={<FileExcelOutlined />}
            onClick={handleExportExcel}
            style={{ backgroundColor: "#52c41a", borderColor: "#52c41a" }}
          >
            Xuất Excel
          </Button>
        )}
      </Space>
    </div>
  );
}
